<template>
  <div>
    <van-tabs v-model="active" line-height="2px" color="#45B9BC" title-active-color="#45B9BC" sticky>
      <van-tab title="未添加">
        <van-list v-model="video_loading" :finished="video_finished" finished-text="没有更多内容啦..." @load="onLoad">
          <div class="storeList flex_center" v-for="(item,index) in itemList" :key="index">
            <div class="storeList__img itemList__img"><img :src="item.thumb_frist" alt=""></div>
            <div class="storeList__content">
              <div>{{item.title}}</div>
              <div class="flex store__item_subtitle">
                <div class="itemList_price fs_12"><span>¥{{item.price}}</span>{{item.time}}分钟/次</div>
                <button class="techList__btn fs_13" @click="addItem_btn(index,item['id'],1)">添加项目</button>
              </div>
            </div>
          </div>
        </van-list>
      </van-tab>
      <van-tab title="已添加">
        <van-list v-model="article_loading" :finished="article_finished" finished-text="没有更多内容啦..." @load="onLoad">
          <div class="storeList flex_center" v-for="(item,index) in addList" :key="index">
            <div class="storeList__img itemList__img"><img :src="item.thumb_frist" alt=""></div>
            <div class="storeList__content">
              <div>{{item.title}}</div>
              <div class="flex store__item_subtitle">
                <div class="itemList_price fs_12"><span>¥{{item.price}}</span>{{item.time}}分钟/次</div>
                <button class="techList__btn fs_13" @click="addItem_btn(idnex,item['id'],-1)">剔除项目</button>
              </div>
            </div>
          </div>
        </van-list>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
  export default {
    name: "store_selectItem",
    data(){
      return{
        store_id:0,
        active: 0,    // 标签当前所在位置
        //未添加-项目列表
        itemList: [
          
        ],
        //已添加-项目列表
        addList: [
         
        ],
        video_loading: false,
        video_finished: true,
        article_loading: false,
        article_finished: true,
      }
    },
    created(){
      this.store_id  =this.$route.query.store_id
      this.get_service();
    },
    methods:{
       get_service(){
        this.axios({
          url: this.api.store.store_select_service,
          data: {
            store_id:this.store_id
          }
        }).then(res => {
          if (res.error === 0) {
            this.itemList  =res.service_list_none;
            this.addList  = res.service_list_choose;
          }
        });
      },
      // 添加项目-按钮
      addItem_btn(index,service_id,type){
        this.$toast('已添加该项目！');
        // this.itemList.splice(index, 1);
        this.axios({
          url: this.api.store.store_service_edit,
          data: {
            store_id:this.store_id,
            service_id:service_id,
            type:type
          }
        }).then(res => {
          if (res.error === 0) {
            var that = this
            if(type==1){
              this.$toast({
                 message: '已添加该项目！',
                 duration:1000,
                 onClose:function(){
                    that.get_service();
                 }, 
              });
            }else{
              this.$toast({
                 message: '剔除成功！',
                 duration:1000,
                 onClose:function(){
                    that.get_service();
                 }, 
              });
            }
            
          }
        });
      },
      // // 剔除项目-按钮
      // deleteItem_btn(index,service_id){
      //   this.$toast('剔除成功！');
      //   this.addList.splice(index, 1);
      // },
      // onLoad() {
      //   // 异步更新数据
      //   setTimeout(() => {
      //     var list;
      //     if (this.active===0){
      //       list=this.itemList;
      //     }else if (this.active===1){
      //       list=this.addList;
      //     }
      //     for (let i = 0; i < 4; i++) {
      //       list.push(list[0]);
      //     }
      //     if (this.active===0){
      //       // 加载状态结束
      //       this.video_loading = false;
      //       // 数据全部加载完成
      //       if (list.length >= 30) {
      //         this.video_finished = true;
      //       }
      //     }else if (this.active===1){
      //       // 加载状态结束
      //       this.article_loading = false;
      //       // 数据全部加载完成
      //       if (list.length >= 30) {
      //         this.article_finished = true;
      //       }
      //     }
      //   }, 500);
      // }
    }
  }
</script>

<style scoped>
  @import '../../assets/css/store.css';   /*门店样式*/
  @import '../../assets/css/item.css';   /*服务项目*/
  @import '../../assets/css/technician.css';   /*技师样式*/
  .store__item_subtitle{
    margin-top: .25rem;
  }
  .storeList{
    margin-bottom: 0;
    border-bottom: 1px solid rgba(231,231,231,.5);
  }
</style>



// WEBPACK FOOTER //
// src/views/store/store_selectItem.vue